import React from 'react'

function OrganizationsDashboardView() {
  return null
}

export default OrganizationsDashboardView
